import { __assign } from "tslib";
import * as WebGPUConstants from './webgpuConstants';
import { VertexBuffer } from "../../Meshes/buffer";
var StatePosition;

(function (StatePosition) {
  //DepthBias = 0, // not used, so remove it to improve perf
  //DepthBiasClamp = 1, // not used, so remove it to improve perf
  StatePosition[StatePosition["StencilReadMask"] = 0] = "StencilReadMask";
  StatePosition[StatePosition["StencilWriteMask"] = 1] = "StencilWriteMask";
  StatePosition[StatePosition["DepthBiasSlopeScale"] = 2] = "DepthBiasSlopeScale";
  StatePosition[StatePosition["MRTAttachments1"] = 3] = "MRTAttachments1";
  StatePosition[StatePosition["MRTAttachments2"] = 4] = "MRTAttachments2";
  StatePosition[StatePosition["DepthStencilState"] = 5] = "DepthStencilState";
  StatePosition[StatePosition["RasterizationState"] = 6] = "RasterizationState";
  StatePosition[StatePosition["ColorStates"] = 7] = "ColorStates";
  StatePosition[StatePosition["ShaderStage"] = 8] = "ShaderStage";
  StatePosition[StatePosition["VertexState"] = 9] = "VertexState";
  StatePosition[StatePosition["NumStates"] = 10] = "NumStates";
})(StatePosition || (StatePosition = {}));

var textureFormatToIndex = {
  "": 0,
  "r8unorm": 1,
  "r8snorm": 2,
  "r8uint": 3,
  "r8sint": 4,
  "r16uint": 5,
  "r16sint": 6,
  "r16float": 7,
  "rg8unorm": 8,
  "rg8snorm": 9,
  "rg8uint": 10,
  "rg8sint": 11,
  "r32uint": 12,
  "r32sint": 13,
  "r32float": 14,
  "rg16uint": 15,
  "rg16sint": 16,
  "rg16float": 17,
  "rgba8unorm": 18,
  "rgba8unorm-srgb": 19,
  "rgba8snorm": 20,
  "rgba8uint": 21,
  "rgba8sint": 22,
  "bgra8unorm": 23,
  "bgra8unorm-srgb": 24,
  "rgb9e5ufloat": 25,
  "rgb10a2unorm": 26,
  "rg11b10ufloat": 27,
  "rg32uint": 28,
  "rg32sint": 29,
  "rg32float": 30,
  "rgba16uint": 31,
  "rgba16sint": 32,
  "rgba16float": 33,
  "rgba32uint": 34,
  "rgba32sint": 35,
  "rgba32float": 36,
  "stencil8": 37,
  "depth16unorm": 38,
  "depth24plus": 39,
  "depth24plus-stencil8": 40,
  "depth32float": 41,
  "bc1-rgba-unorm": 42,
  "bc1-rgba-unorm-srgb": 43,
  "bc2-rgba-unorm": 44,
  "bc2-rgba-unorm-srgb": 45,
  "bc3-rgba-unorm": 46,
  "bc3-rgba-unorm-srgb": 47,
  "bc4-r-unorm": 48,
  "bc4-r-snorm": 49,
  "bc5-rg-unorm": 50,
  "bc5-rg-snorm": 51,
  "bc6h-rgb-ufloat": 52,
  "bc6h-rgb-float": 53,
  "bc7-rgba-unorm": 54,
  "bc7-rgba-unorm-srgb": 55,
  "depth24unorm-stencil8": 56,
  "depth32float-stencil8": 57
};
var alphaBlendFactorToIndex = {
  0: 1,
  1: 2,
  0x0300: 3,
  0x0301: 4,
  0x0302: 5,
  0x0303: 6,
  0x0304: 7,
  0x0305: 8,
  0x0306: 9,
  0x0307: 10,
  0x0308: 11,
  0x8001: 12,
  0x8002: 13,
  0x8003: 12,
  0x8004: 13 // OneMinusBlendColor (alpha)

};
var stencilOpToIndex = {
  0x0000: 0,
  0x1E00: 1,
  0x1E01: 2,
  0x1E02: 3,
  0x1E03: 4,
  0x150A: 5,
  0x8507: 6,
  0x8508: 7 // DECR_WRAP

};
/** @hidden */

var WebGPUCacheRenderPipeline =
/** @class */
function () {
  function WebGPUCacheRenderPipeline(device, emptyVertexBuffer) {
    this._device = device;
    this._states = [];
    this._states.length = StatePosition.NumStates;
    this._stateDirtyLowestIndex = 0;
    this._emptyVertexBuffer = emptyVertexBuffer;
    this._mrtFormats = [];
    this._parameter = {
      token: undefined,
      pipeline: null
    };
    this.disabled = false;
    this.reset();
  }

  WebGPUCacheRenderPipeline.prototype.reset = function () {
    this._isDirty = true;
    this.setAlphaToCoverage(false);
    this.resetDepthCullingState();
    this.setClampDepth(false); //this.setDepthBias(0);
    //this.setDepthBiasClamp(0);

    this.setColorFormat(WebGPUConstants.TextureFormat.BGRA8Unorm);
    this.setMRTAttachments([], []);
    this.setAlphaBlendEnabled(false);
    this.setAlphaBlendFactors([null, null, null, null], [null, null]);
    this.setWriteMask(0xF);
    this.setDepthStencilFormat(WebGPUConstants.TextureFormat.Depth24PlusStencil8);
    this.setStencilEnabled(false);
    this.resetStencilState();
    this.setBuffers(null, null, null);
  };

  WebGPUCacheRenderPipeline.prototype.getRenderPipeline = function (fillMode, effect, sampleCount) {
    if (this.disabled) {
      var topology_1 = WebGPUCacheRenderPipeline._GetTopology(fillMode);

      this._parameter.pipeline = this._createRenderPipeline(effect, topology_1, sampleCount);
      WebGPUCacheRenderPipeline.NumCacheMiss++;
      WebGPUCacheRenderPipeline._NumPipelineCreationCurrentFrame++;
      return this._parameter.pipeline;
    }

    this._setShaderStage(effect.uniqueId);

    this._setRasterizationState(fillMode, sampleCount);

    this._setColorStates();

    this._setDepthStencilState();

    this._setVertexState(effect);

    this.lastStateDirtyLowestIndex = this._stateDirtyLowestIndex;

    if (!this._isDirty && this._parameter.pipeline) {
      this._stateDirtyLowestIndex = this._states.length;
      WebGPUCacheRenderPipeline.NumCacheHitWithoutHash++;
      return this._parameter.pipeline;
    }

    this._getRenderPipeline(this._parameter);

    this._isDirty = false;
    this._stateDirtyLowestIndex = this._states.length;

    if (this._parameter.pipeline) {
      WebGPUCacheRenderPipeline.NumCacheHitWithHash++;
      return this._parameter.pipeline;
    }

    var topology = WebGPUCacheRenderPipeline._GetTopology(fillMode);

    this._parameter.pipeline = this._createRenderPipeline(effect, topology, sampleCount);

    this._setRenderPipeline(this._parameter);

    WebGPUCacheRenderPipeline.NumCacheMiss++;
    WebGPUCacheRenderPipeline._NumPipelineCreationCurrentFrame++;
    return this._parameter.pipeline;
  };

  WebGPUCacheRenderPipeline.prototype.endFrame = function () {
    WebGPUCacheRenderPipeline.NumPipelineCreationLastFrame = WebGPUCacheRenderPipeline._NumPipelineCreationCurrentFrame;
    WebGPUCacheRenderPipeline._NumPipelineCreationCurrentFrame = 0;
  };

  WebGPUCacheRenderPipeline.prototype.setAlphaToCoverage = function (enabled) {
    this._alphaToCoverageEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setFrontFace = function (frontFace) {
    this._frontFace = frontFace;
  };

  WebGPUCacheRenderPipeline.prototype.setCullEnabled = function (enabled) {
    this._cullEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setCullFace = function (cullFace) {
    this._cullFace = cullFace;
  };

  WebGPUCacheRenderPipeline.prototype.setClampDepth = function (clampDepth) {
    this._clampDepth = clampDepth;
  };

  WebGPUCacheRenderPipeline.prototype.resetDepthCullingState = function () {
    this.setDepthCullingState(false, 2, 1, 0, true, true, 519);
  };

  WebGPUCacheRenderPipeline.prototype.setDepthCullingState = function (cullEnabled, frontFace, cullFace, zOffset, depthTestEnabled, depthWriteEnabled, depthCompare) {
    this._depthWriteEnabled = depthWriteEnabled;
    this._depthTestEnabled = depthTestEnabled;
    this._depthCompare = (depthCompare !== null && depthCompare !== void 0 ? depthCompare : 519) - 0x0200;
    this._cullFace = cullFace;
    this._cullEnabled = cullEnabled;
    this._frontFace = frontFace;
    this.setDepthBiasSlopeScale(zOffset);
  };
  /*public setDepthBias(depthBias: number): void {
      if (this._depthBias !== depthBias) {
          this._depthBias = depthBias;
          this._states[StatePosition.DepthBias] = depthBias.toString();
          this._isDirty = true;
      }
  }
    public setDepthBiasClamp(depthBiasClamp: number): void {
      if (this._depthBiasClamp !== depthBiasClamp) {
          this._depthBiasClamp = depthBiasClamp;
          this._states[StatePosition.DepthBiasClamp] = depthBiasClamp.toString();
          this._isDirty = true;
      }
  }*/


  WebGPUCacheRenderPipeline.prototype.setDepthBiasSlopeScale = function (depthBiasSlopeScale) {
    if (this._depthBiasSlopeScale !== depthBiasSlopeScale) {
      this._depthBiasSlopeScale = depthBiasSlopeScale;
      this._states[StatePosition.DepthBiasSlopeScale] = depthBiasSlopeScale;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.DepthBiasSlopeScale);
    }
  };

  WebGPUCacheRenderPipeline.prototype.setColorFormat = function (format) {
    this._webgpuColorFormat = format;
    this._colorFormat = textureFormatToIndex[format];
  };

  WebGPUCacheRenderPipeline.prototype.setMRTAttachments = function (attachments, textureArray) {
    var _a;

    if (attachments.length > 10) {
      // If we want more than 10 attachments we need to change this method but 10 seems plenty
      // Note we can do better without changing this method if only dealing with texture formats that can be used as output attachments
      // It could allow to use 5 bits (or even less) to code a texture format. For the time being, we use 6 bits as we need 58 different values (2^6=64)
      // so we can encode 5 texture formats in 32 bits
      throw "Can't handle more than 10 attachments for a MRT in cache render pipeline!";
    }

    var bits = [0, 0],
        indexBits = 0,
        mask = 0,
        numRT = 0;

    for (var i = 0; i < attachments.length; ++i) {
      var index = attachments[i];

      if (index === 0) {
        continue;
      }

      var texture = textureArray[index - 1];
      var gpuWrapper = texture === null || texture === void 0 ? void 0 : texture._hardwareTexture;
      this._mrtFormats[numRT] = (_a = gpuWrapper === null || gpuWrapper === void 0 ? void 0 : gpuWrapper.format) !== null && _a !== void 0 ? _a : this._webgpuColorFormat;
      bits[indexBits] += textureFormatToIndex[this._mrtFormats[numRT]] << mask;
      mask += 6;
      numRT++;

      if (mask >= 32) {
        mask = 0;
        indexBits++;
      }
    }

    this._mrtFormats.length = numRT;

    if (this._mrtAttachments1 !== bits[0] || this._mrtAttachments2 !== bits[1]) {
      this._mrtAttachments1 = bits[0];
      this._mrtAttachments2 = bits[1];
      this._states[StatePosition.MRTAttachments1] = bits[0];
      this._states[StatePosition.MRTAttachments2] = bits[1];
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.MRTAttachments1);
    }
  };

  WebGPUCacheRenderPipeline.prototype.setAlphaBlendEnabled = function (enabled) {
    this._alphaBlendEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setAlphaBlendFactors = function (factors, operations) {
    this._alphaBlendFuncParams = factors;
    this._alphaBlendEqParams = operations;
  };

  WebGPUCacheRenderPipeline.prototype.setWriteMask = function (mask) {
    this._writeMask = mask;
  };

  WebGPUCacheRenderPipeline.prototype.setDepthStencilFormat = function (format) {
    this._webgpuDepthStencilFormat = format;
    this._depthStencilFormat = format === undefined ? 0 : textureFormatToIndex[format];
  };

  WebGPUCacheRenderPipeline.prototype.setDepthTestEnabled = function (enabled) {
    this._depthTestEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setDepthWriteEnabled = function (enabled) {
    this._depthWriteEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setDepthCompare = function (func) {
    this._depthCompare = (func !== null && func !== void 0 ? func : 519) - 0x0200;
  };

  WebGPUCacheRenderPipeline.prototype.setStencilEnabled = function (enabled) {
    this._stencilEnabled = enabled;
  };

  WebGPUCacheRenderPipeline.prototype.setStencilCompare = function (func) {
    this._stencilFrontCompare = (func !== null && func !== void 0 ? func : 519) - 0x0200;
  };

  WebGPUCacheRenderPipeline.prototype.setStencilDepthFailOp = function (op) {
    this._stencilFrontDepthFailOp = op === null ? 1
    /* KEEP */
    : stencilOpToIndex[op];
  };

  WebGPUCacheRenderPipeline.prototype.setStencilPassOp = function (op) {
    this._stencilFrontPassOp = op === null ? 2
    /* REPLACE */
    : stencilOpToIndex[op];
  };

  WebGPUCacheRenderPipeline.prototype.setStencilFailOp = function (op) {
    this._stencilFrontFailOp = op === null ? 1
    /* KEEP */
    : stencilOpToIndex[op];
  };

  WebGPUCacheRenderPipeline.prototype.setStencilReadMask = function (mask) {
    if (this._stencilReadMask !== mask) {
      this._stencilReadMask = mask;
      this._states[StatePosition.StencilReadMask] = mask;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.StencilReadMask);
    }
  };

  WebGPUCacheRenderPipeline.prototype.setStencilWriteMask = function (mask) {
    if (this._stencilWriteMask !== mask) {
      this._stencilWriteMask = mask;
      this._states[StatePosition.StencilWriteMask] = mask;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.StencilWriteMask);
    }
  };

  WebGPUCacheRenderPipeline.prototype.resetStencilState = function () {
    this.setStencilState(false, 519, 7680, 7681, 7680, 0xFF, 0xFF);
  };

  WebGPUCacheRenderPipeline.prototype.setStencilState = function (stencilEnabled, compare, depthFailOp, passOp, failOp, readMask, writeMask) {
    this._stencilEnabled = stencilEnabled;
    this._stencilFrontCompare = (compare !== null && compare !== void 0 ? compare : 519) - 0x0200;
    this._stencilFrontDepthFailOp = depthFailOp === null ? 1
    /* KEEP */
    : stencilOpToIndex[depthFailOp];
    this._stencilFrontPassOp = passOp === null ? 2
    /* REPLACE */
    : stencilOpToIndex[passOp];
    this._stencilFrontFailOp = failOp === null ? 1
    /* KEEP */
    : stencilOpToIndex[failOp];
    this.setStencilReadMask(readMask);
    this.setStencilWriteMask(writeMask);
  };

  WebGPUCacheRenderPipeline.prototype.setBuffers = function (vertexBuffers, indexBuffer, overrideVertexBuffers) {
    this._vertexBuffers = vertexBuffers;
    this._overrideVertexBuffers = overrideVertexBuffers;
    this._indexBuffer = indexBuffer;
  };

  WebGPUCacheRenderPipeline._GetTopology = function (fillMode) {
    switch (fillMode) {
      // Triangle views
      case 0:
        return WebGPUConstants.PrimitiveTopology.TriangleList;

      case 2:
        return WebGPUConstants.PrimitiveTopology.PointList;

      case 1:
        return WebGPUConstants.PrimitiveTopology.LineList;
      // Draw modes

      case 3:
        return WebGPUConstants.PrimitiveTopology.PointList;

      case 4:
        return WebGPUConstants.PrimitiveTopology.LineList;

      case 5:
        // return this._gl.LINE_LOOP;
        // TODO WEBGPU. Line Loop Mode Fallback at buffer load time.
        throw "LineLoop is an unsupported fillmode in WebGPU";

      case 6:
        return WebGPUConstants.PrimitiveTopology.LineStrip;

      case 7:
        return WebGPUConstants.PrimitiveTopology.TriangleStrip;

      case 8:
        // return this._gl.TRIANGLE_FAN;
        // TODO WEBGPU. Triangle Fan Mode Fallback at buffer load time.
        throw "TriangleFan is an unsupported fillmode in WebGPU";

      default:
        return WebGPUConstants.PrimitiveTopology.TriangleList;
    }
  };

  WebGPUCacheRenderPipeline._GetAphaBlendOperation = function (operation) {
    switch (operation) {
      case 0x8006:
        return WebGPUConstants.BlendOperation.Add;

      case 0x800A:
        return WebGPUConstants.BlendOperation.Subtract;

      case 0x800B:
        return WebGPUConstants.BlendOperation.ReverseSubtract;

      case 0x8007:
        return WebGPUConstants.BlendOperation.Min;

      case 0x8008:
        return WebGPUConstants.BlendOperation.Max;

      default:
        return WebGPUConstants.BlendOperation.Add;
    }
  };

  WebGPUCacheRenderPipeline._GetAphaBlendFactor = function (factor) {
    switch (factor) {
      case 0:
        return WebGPUConstants.BlendFactor.Zero;

      case 1:
        return WebGPUConstants.BlendFactor.One;

      case 0x0300:
        return WebGPUConstants.BlendFactor.SrcColor;

      case 0x0301:
        return WebGPUConstants.BlendFactor.OneMinusSrcColor;

      case 0x0302:
        return WebGPUConstants.BlendFactor.SrcAlpha;

      case 0x0303:
        return WebGPUConstants.BlendFactor.OneMinusSrcAlpha;

      case 0x0304:
        return WebGPUConstants.BlendFactor.DstAlpha;

      case 0x0305:
        return WebGPUConstants.BlendFactor.OneMinusDstAlpha;

      case 0x0306:
        return WebGPUConstants.BlendFactor.DstColor;

      case 0x0307:
        return WebGPUConstants.BlendFactor.OneMinusDstColor;

      case 0x0308:
        return WebGPUConstants.BlendFactor.SrcAlphaSaturated;

      case 0x8001:
        return WebGPUConstants.BlendFactor.BlendColor;

      case 0x8002:
        return WebGPUConstants.BlendFactor.OneMinusBlendColor;

      case 0x8003:
        return WebGPUConstants.BlendFactor.BlendColor;

      case 0x8004:
        return WebGPUConstants.BlendFactor.OneMinusBlendColor;

      default:
        return WebGPUConstants.BlendFactor.One;
    }
  };

  WebGPUCacheRenderPipeline._GetCompareFunction = function (compareFunction) {
    switch (compareFunction) {
      case 0:
        // NEVER
        return WebGPUConstants.CompareFunction.Never;

      case 1:
        // LESS
        return WebGPUConstants.CompareFunction.Less;

      case 2:
        // EQUAL
        return WebGPUConstants.CompareFunction.Equal;

      case 3:
        // LEQUAL
        return WebGPUConstants.CompareFunction.LessEqual;

      case 4:
        // GREATER
        return WebGPUConstants.CompareFunction.Greater;

      case 5:
        // NOTEQUAL
        return WebGPUConstants.CompareFunction.NotEqual;

      case 6:
        // GEQUAL
        return WebGPUConstants.CompareFunction.GreaterEqual;

      case 7:
        // ALWAYS
        return WebGPUConstants.CompareFunction.Always;
    }

    return WebGPUConstants.CompareFunction.Never;
  };

  WebGPUCacheRenderPipeline._GetStencilOpFunction = function (operation) {
    switch (operation) {
      case 0:
        return WebGPUConstants.StencilOperation.Zero;

      case 1:
        return WebGPUConstants.StencilOperation.Keep;

      case 2:
        return WebGPUConstants.StencilOperation.Replace;

      case 3:
        return WebGPUConstants.StencilOperation.IncrementClamp;

      case 4:
        return WebGPUConstants.StencilOperation.DecrementClamp;

      case 5:
        return WebGPUConstants.StencilOperation.Invert;

      case 6:
        return WebGPUConstants.StencilOperation.IncrementWrap;

      case 7:
        return WebGPUConstants.StencilOperation.DecrementWrap;
    }

    return WebGPUConstants.StencilOperation.Keep;
  };

  WebGPUCacheRenderPipeline._GetVertexInputDescriptorFormat = function (vertexBuffer) {
    var type = vertexBuffer.type;
    var normalized = vertexBuffer.normalized;
    var size = vertexBuffer.getSize();

    switch (type) {
      case VertexBuffer.BYTE:
        switch (size) {
          case 1:
          case 2:
            return normalized ? WebGPUConstants.VertexFormat.Snorm8x2 : WebGPUConstants.VertexFormat.Sint8x2;

          case 3:
          case 4:
            return normalized ? WebGPUConstants.VertexFormat.Snorm8x4 : WebGPUConstants.VertexFormat.Sint8x4;
        }

        break;

      case VertexBuffer.UNSIGNED_BYTE:
        switch (size) {
          case 1:
          case 2:
            return normalized ? WebGPUConstants.VertexFormat.Unorm8x2 : WebGPUConstants.VertexFormat.Uint8x2;

          case 3:
          case 4:
            return normalized ? WebGPUConstants.VertexFormat.Unorm8x4 : WebGPUConstants.VertexFormat.Uint8x4;
        }

        break;

      case VertexBuffer.SHORT:
        switch (size) {
          case 1:
          case 2:
            return normalized ? WebGPUConstants.VertexFormat.Snorm16x2 : WebGPUConstants.VertexFormat.Sint16x2;

          case 3:
          case 4:
            return normalized ? WebGPUConstants.VertexFormat.Snorm16x4 : WebGPUConstants.VertexFormat.Sint16x4;
        }

        break;

      case VertexBuffer.UNSIGNED_SHORT:
        switch (size) {
          case 1:
          case 2:
            return normalized ? WebGPUConstants.VertexFormat.Unorm16x2 : WebGPUConstants.VertexFormat.Uint16x2;

          case 3:
          case 4:
            return normalized ? WebGPUConstants.VertexFormat.Unorm16x4 : WebGPUConstants.VertexFormat.Uint16x4;
        }

        break;

      case VertexBuffer.INT:
        switch (size) {
          case 1:
            return WebGPUConstants.VertexFormat.Sint32;

          case 2:
            return WebGPUConstants.VertexFormat.Sint32x2;

          case 3:
            return WebGPUConstants.VertexFormat.Sint32x3;

          case 4:
            return WebGPUConstants.VertexFormat.Sint32x4;
        }

        break;

      case VertexBuffer.UNSIGNED_INT:
        switch (size) {
          case 1:
            return WebGPUConstants.VertexFormat.Uint32;

          case 2:
            return WebGPUConstants.VertexFormat.Uint32x2;

          case 3:
            return WebGPUConstants.VertexFormat.Uint32x3;

          case 4:
            return WebGPUConstants.VertexFormat.Uint32x4;
        }

        break;

      case VertexBuffer.FLOAT:
        switch (size) {
          case 1:
            return WebGPUConstants.VertexFormat.Float32;

          case 2:
            return WebGPUConstants.VertexFormat.Float32x2;

          case 3:
            return WebGPUConstants.VertexFormat.Float32x3;

          case 4:
            return WebGPUConstants.VertexFormat.Float32x4;
        }

        break;
    }

    throw new Error("Invalid Format '" + vertexBuffer.getKind() + "' - type=" + type + ", normalized=" + normalized + ", size=" + size);
  };

  WebGPUCacheRenderPipeline.prototype._getAphaBlendState = function () {
    if (!this._alphaBlendEnabled) {
      return {};
    }

    return {
      srcFactor: WebGPUCacheRenderPipeline._GetAphaBlendFactor(this._alphaBlendFuncParams[2]),
      dstFactor: WebGPUCacheRenderPipeline._GetAphaBlendFactor(this._alphaBlendFuncParams[3]),
      operation: WebGPUCacheRenderPipeline._GetAphaBlendOperation(this._alphaBlendEqParams[1])
    };
  };

  WebGPUCacheRenderPipeline.prototype._getColorBlendState = function () {
    if (!this._alphaBlendEnabled) {
      return {};
    }

    return {
      srcFactor: WebGPUCacheRenderPipeline._GetAphaBlendFactor(this._alphaBlendFuncParams[0]),
      dstFactor: WebGPUCacheRenderPipeline._GetAphaBlendFactor(this._alphaBlendFuncParams[1]),
      operation: WebGPUCacheRenderPipeline._GetAphaBlendOperation(this._alphaBlendEqParams[0])
    };
  };

  WebGPUCacheRenderPipeline.prototype._setShaderStage = function (id) {
    if (this._shaderId !== id) {
      this._shaderId = id;
      this._states[StatePosition.ShaderStage] = id;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.ShaderStage);
    }
  };

  WebGPUCacheRenderPipeline.prototype._setRasterizationState = function (topology, sampleCount) {
    var frontFace = this._frontFace;
    var cullMode = this._cullEnabled ? this._cullFace : 0;
    var clampDepth = this._clampDepth ? 1 : 0;
    var alphaToCoverage = this._alphaToCoverageEnabled ? 1 : 0;
    var rasterizationState = frontFace - 1 + (cullMode << 1) + (clampDepth << 3) + (alphaToCoverage << 4) + (topology << 5) + (sampleCount << 8);

    if (this._rasterizationState !== rasterizationState) {
      this._rasterizationState = rasterizationState;
      this._states[StatePosition.RasterizationState] = this._rasterizationState;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.RasterizationState);
    }
  };

  WebGPUCacheRenderPipeline.prototype._setColorStates = function () {
    var colorStates = ((this._writeMask ? 1 : 0) << 22) + (this._colorFormat << 23) + ((this._depthWriteEnabled ? 1 : 0) << 29); // this state has been moved from depthStencilState here because alpha and depth are related (generally when alpha is on, depth write is off and the other way around)

    if (this._alphaBlendEnabled) {
      colorStates += ((this._alphaBlendFuncParams[0] === null ? 2 : alphaBlendFactorToIndex[this._alphaBlendFuncParams[0]]) << 0) + ((this._alphaBlendFuncParams[1] === null ? 2 : alphaBlendFactorToIndex[this._alphaBlendFuncParams[1]]) << 4) + ((this._alphaBlendFuncParams[2] === null ? 2 : alphaBlendFactorToIndex[this._alphaBlendFuncParams[2]]) << 8) + ((this._alphaBlendFuncParams[3] === null ? 2 : alphaBlendFactorToIndex[this._alphaBlendFuncParams[3]]) << 12) + ((this._alphaBlendEqParams[0] === null ? 1 : this._alphaBlendEqParams[0] - 0x8005) << 16) + ((this._alphaBlendEqParams[1] === null ? 1 : this._alphaBlendEqParams[1] - 0x8005) << 19);
    }

    if (colorStates !== this._colorStates) {
      this._colorStates = colorStates;
      this._states[StatePosition.ColorStates] = this._colorStates;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.ColorStates);
    }
  };

  WebGPUCacheRenderPipeline.prototype._setDepthStencilState = function () {
    var stencilState = !this._stencilEnabled ? 7
    /* ALWAYS */
    + (1
    /* KEEP */
    << 3) + (1
    /* KEEP */
    << 6) + (1
    /* KEEP */
    << 9) : this._stencilFrontCompare + (this._stencilFrontDepthFailOp << 3) + (this._stencilFrontPassOp << 6) + (this._stencilFrontFailOp << 9);
    var depthStencilState = this._depthStencilFormat + ((this._depthTestEnabled ? this._depthCompare : 7
    /* ALWAYS */
    ) << 6) + (stencilState << 10); // stencil front - stencil back is the same

    if (this._depthStencilState !== depthStencilState) {
      this._depthStencilState = depthStencilState;
      this._states[StatePosition.DepthStencilState] = this._depthStencilState;
      this._isDirty = true;
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.DepthStencilState);
    }
  };

  WebGPUCacheRenderPipeline.prototype._setVertexState = function (effect) {
    var _a;

    var currStateLen = this._states.length;
    var newNumStates = StatePosition.VertexState;
    var webgpuPipelineContext = effect._pipelineContext;
    var attributes = webgpuPipelineContext.shaderProcessingContext.attributeNamesFromEffect;
    var locations = webgpuPipelineContext.shaderProcessingContext.attributeLocationsFromEffect;

    for (var index = 0; index < attributes.length; index++) {
      var location_1 = locations[index];
      var vertexBuffer = (_a = this._overrideVertexBuffers && this._overrideVertexBuffers[attributes[index]]) !== null && _a !== void 0 ? _a : this._vertexBuffers[attributes[index]];

      if (!vertexBuffer) {
        // In WebGL it's valid to not bind a vertex buffer to an attribute, but it's not valid in WebGPU
        // So we must bind a dummy buffer when we are not given one for a specific attribute
        vertexBuffer = this._emptyVertexBuffer;
      }

      var vid = vertexBuffer.hashCode + (location_1 << 7);
      this._isDirty = this._isDirty || this._states[newNumStates] !== vid;
      this._states[newNumStates++] = vid;
    }

    this._states.length = newNumStates;
    this._isDirty = this._isDirty || newNumStates !== currStateLen;

    if (this._isDirty) {
      this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, StatePosition.VertexState);
    }
  };

  WebGPUCacheRenderPipeline.prototype._createPipelineLayout = function (webgpuPipelineContext) {
    var bindGroupLayouts = [];

    for (var i = 0; i < webgpuPipelineContext.shaderProcessingContext.orderedUBOsAndSamplers.length; i++) {
      var setDefinition = webgpuPipelineContext.shaderProcessingContext.orderedUBOsAndSamplers[i];

      if (setDefinition === undefined) {
        var entries_1 = [];

        var uniformsBindGroupLayout = this._device.createBindGroupLayout({
          entries: entries_1
        });

        bindGroupLayouts[i] = uniformsBindGroupLayout;
        continue;
      }

      var entries = [];

      for (var j = 0; j < setDefinition.length; j++) {
        var bindingDefinition = webgpuPipelineContext.shaderProcessingContext.orderedUBOsAndSamplers[i][j];

        if (bindingDefinition === undefined) {
          continue;
        }

        var visibility = 0;

        if (bindingDefinition.usedInVertex) {
          visibility = visibility | WebGPUConstants.ShaderStage.Vertex;
        }

        if (bindingDefinition.usedInFragment) {
          visibility = visibility | WebGPUConstants.ShaderStage.Fragment;
        }

        var entry = {
          binding: j,
          visibility: visibility
        };
        entries.push(entry);

        if (bindingDefinition.isSampler) {
          entry.sampler = {
            type: bindingDefinition.isComparisonSampler ? WebGPUConstants.SamplerBindingType.Comparison : WebGPUConstants.SamplerBindingType.Filtering
          };
        } else if (bindingDefinition.isTexture) {
          entry.texture = {
            sampleType: bindingDefinition.sampleType,
            viewDimension: bindingDefinition.textureDimension,
            multisampled: false
          };
        } else {
          entry.buffer = {
            type: WebGPUConstants.BufferBindingType.Uniform
          };
        }
      }

      if (entries.length > 0) {
        var uniformsBindGroupLayout = this._device.createBindGroupLayout({
          entries: entries
        });

        bindGroupLayouts[i] = uniformsBindGroupLayout;
      }
    }

    webgpuPipelineContext.bindGroupLayouts = bindGroupLayouts;
    return this._device.createPipelineLayout({
      bindGroupLayouts: bindGroupLayouts
    });
  };

  WebGPUCacheRenderPipeline.prototype._getVertexInputDescriptor = function (effect, topology) {
    var _a;

    var descriptors = [];
    var webgpuPipelineContext = effect._pipelineContext;
    var attributes = webgpuPipelineContext.shaderProcessingContext.attributeNamesFromEffect;
    var locations = webgpuPipelineContext.shaderProcessingContext.attributeLocationsFromEffect;

    for (var index = 0; index < attributes.length; index++) {
      var location_2 = locations[index];
      var vertexBuffer = (_a = this._overrideVertexBuffers && this._overrideVertexBuffers[attributes[index]]) !== null && _a !== void 0 ? _a : this._vertexBuffers[attributes[index]];

      if (!vertexBuffer) {
        // In WebGL it's valid to not bind a vertex buffer to an attribute, but it's not valid in WebGPU
        // So we must bind a dummy buffer when we are not given one for a specific attribute
        vertexBuffer = this._emptyVertexBuffer;
      }

      var attributeDescriptor = {
        shaderLocation: location_2,
        offset: 0,
        format: WebGPUCacheRenderPipeline._GetVertexInputDescriptorFormat(vertexBuffer)
      }; // TODO WEBGPU. Factorize the one with the same underlying buffer.

      var vertexBufferDescriptor = {
        arrayStride: vertexBuffer.byteStride,
        stepMode: vertexBuffer.getIsInstanced() ? WebGPUConstants.InputStepMode.Instance : WebGPUConstants.InputStepMode.Vertex,
        attributes: [attributeDescriptor]
      };
      descriptors.push(vertexBufferDescriptor);
    }

    var inputStateDescriptor = {
      vertexBuffers: descriptors
    };

    if (topology === WebGPUConstants.PrimitiveTopology.LineStrip || topology === WebGPUConstants.PrimitiveTopology.TriangleStrip) {
      inputStateDescriptor.indexFormat = !this._indexBuffer || this._indexBuffer.is32Bits ? WebGPUConstants.IndexFormat.Uint32 : WebGPUConstants.IndexFormat.Uint16;
    }

    return inputStateDescriptor;
  };

  WebGPUCacheRenderPipeline.prototype._createRenderPipeline = function (effect, topology, sampleCount, createLayout) {
    if (createLayout === void 0) {
      createLayout = true;
    }

    var webgpuPipelineContext = effect._pipelineContext;

    var inputStateDescriptor = this._getVertexInputDescriptor(effect, topology);

    var pipelineLayout = createLayout ? this._createPipelineLayout(webgpuPipelineContext) : undefined;
    var colorStates = [];

    var alphaBlend = this._getAphaBlendState();

    var colorBlend = this._getColorBlendState();

    if (this._mrtAttachments1 > 0) {
      for (var i = 0; i < this._mrtFormats.length; ++i) {
        colorStates.push({
          format: this._mrtFormats[i],
          alphaBlend: alphaBlend,
          colorBlend: colorBlend,
          writeMask: this._writeMask
        });
      }
    } else {
      colorStates.push({
        format: this._webgpuColorFormat,
        alphaBlend: alphaBlend,
        colorBlend: colorBlend,
        writeMask: this._writeMask
      });
    }

    var stencilFrontBack = {
      compare: WebGPUCacheRenderPipeline._GetCompareFunction(this._stencilFrontCompare),
      depthFailOp: WebGPUCacheRenderPipeline._GetStencilOpFunction(this._stencilFrontDepthFailOp),
      failOp: WebGPUCacheRenderPipeline._GetStencilOpFunction(this._stencilFrontFailOp),
      passOp: WebGPUCacheRenderPipeline._GetStencilOpFunction(this._stencilFrontPassOp)
    };
    return this._device.createRenderPipeline(__assign(__assign({
      layout: pipelineLayout
    }, webgpuPipelineContext.stages), {
      primitiveTopology: topology,
      rasterizationState: {
        frontFace: this._frontFace === 1 ? WebGPUConstants.FrontFace.CCW : WebGPUConstants.FrontFace.CW,
        cullMode: !this._cullEnabled ? WebGPUConstants.CullMode.None : this._cullFace === 2 ? WebGPUConstants.CullMode.Front : WebGPUConstants.CullMode.Back,
        depthBias: this._depthBias,
        depthBiasClamp: this._depthBiasClamp,
        depthBiasSlopeScale: this._depthBiasSlopeScale
      },
      colorStates: colorStates,
      sampleCount: sampleCount,
      depthStencilState: this._webgpuDepthStencilFormat === undefined ? undefined : {
        depthWriteEnabled: this._depthWriteEnabled,
        depthCompare: this._depthTestEnabled ? WebGPUCacheRenderPipeline._GetCompareFunction(this._depthCompare) : WebGPUConstants.CompareFunction.Always,
        format: this._webgpuDepthStencilFormat,
        stencilFront: stencilFrontBack,
        stencilBack: stencilFrontBack,
        stencilReadMask: this._stencilReadMask,
        stencilWriteMask: this._stencilWriteMask
      },
      vertexState: inputStateDescriptor
    }));
  };

  WebGPUCacheRenderPipeline.NumCacheHitWithoutHash = 0;
  WebGPUCacheRenderPipeline.NumCacheHitWithHash = 0;
  WebGPUCacheRenderPipeline.NumCacheMiss = 0;
  WebGPUCacheRenderPipeline.NumPipelineCreationLastFrame = 0;
  WebGPUCacheRenderPipeline._NumPipelineCreationCurrentFrame = 0;
  return WebGPUCacheRenderPipeline;
}();

export { WebGPUCacheRenderPipeline };